import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function HeartIcon({
  size,
  color,
  isSelected,
  hasStroke = false,
}: {
  size: number;
  color: DripsyColor;
  isSelected: boolean;
  hasStroke?: boolean;
}) {
  const finalColor = useDripsyColor({ color });
  const selectedColor = useDripsyColor({ color: "$error" });

  return (
    <Svg width={size} height={size} viewBox="0 0 20 19">
      {isSelected ? (
        <G stroke="none" strokeWidth="1" fill="#000000" />
      ) : (
        <G stroke="none" strokeWidth="1" fill="none" />
      )}
      {isSelected ? (
        <>
          <Path
            fill={selectedColor}
            d="M10,18.35 L8.55,17.03 C3.4,12.36 0,9.27 0,5.5 C0,2.41 2.42,0 5.5,0 C7.24,0 8.91,0.81 10,2.08 C11.09,0.81 12.76,0 14.5,0 C17.58,0 20,2.41 20,5.5 C20,9.27 16.6,12.36 11.45,17.03 L10,18.35 Z"
          />
          {hasStroke ? (
            <Path
              fill={finalColor}
              d="M10.1,15.55 L10,15.65 L9.89,15.55 C5.14,11.24 2,8.39 2,5.5 C2,3.5 3.5,2 5.5,2 C7.04,2 8.54,3 9.07,4.36 L10.93,4.36 C11.46,3 12.96,2 14.5,2 C16.5,2 18,3.5 18,5.5 C18,8.39 14.86,11.24 10.1,15.55 M14.5,0 C12.76,0 11.09,0.81 10,2.08 C8.91,0.81 7.24,0 5.5,0 C2.42,0 0,2.41 0,5.5 C0,9.27 3.4,12.36 8.55,17.03 L10,18.35 L11.45,17.03 C16.6,12.36 20,9.27 20,5.5 C20,2.41 17.58,0 14.5,0 Z"
            />
          ) : null}
        </>
      ) : (
        <Path
          fill={finalColor}
          d="M10.1,15.55 L10,15.65 L9.89,15.55 C5.14,11.24 2,8.39 2,5.5 C2,3.5 3.5,2 5.5,2 C7.04,2 8.54,3 9.07,4.36 L10.93,4.36 C11.46,3 12.96,2 14.5,2 C16.5,2 18,3.5 18,5.5 C18,8.39 14.86,11.24 10.1,15.55 M14.5,0 C12.76,0 11.09,0.81 10,2.08 C8.91,0.81 7.24,0 5.5,0 C2.42,0 0,2.41 0,5.5 C0,9.27 3.4,12.36 8.55,17.03 L10,18.35 L11.45,17.03 C16.6,12.36 20,9.27 20,5.5 C20,2.41 17.58,0 14.5,0 Z"
        />
      )}
    </Svg>
  );
}
export default HeartIcon;
